<template>
  <div class="user-page__content">
    <template v-if="favorites && favorites.length">
      <ProductsTableComponent
        v-if="favorites && favorites.length"
        @remove="remove"
        :items="favorites"
        is-wishlist
      />
      <!--      <div class="user-page__footer">-->
      <!--        <button type="button" class="btn btn&#45;&#45;md btn&#45;&#45;main">Отправить друзьям</button>-->
      <!--      </div>-->

      <div class="wishlist-page-aside__share">
        <button
          type="button"
          class="btn btn--md"
          :class="sharedWishlistCopied ? 'btn--main' : 'btn--main-outline'"
          :disabled="shareLoading || favorites.length === 0"
          @click="shareWishlist"
        >
          <FileIconComponent v-show="shareLoading" name="loading" class="main-color" />
          <IconComponent
            v-show="!shareLoading"
            :name="sharedWishlistCopied ? 'icon-tick-square' : 'icon-export-circle'"
          />
          <span>
            {{ sharedWishlistCopied ? "Ссылка скопирована" : "Поделиться списком желаний" }}
          </span>
        </button>
        <button
          type="button"
          class="btn btn--md btn--main-outline"
          :disabled="pdfLoading"
          @click="downloadPdf"
        >
          <FileIconComponent v-show="pdfLoading" name="loading" class="main-color" />
          <IconComponent v-show="!pdfLoading" name="document-upload" />
          <span>Скачать файлом</span>
        </button>
      </div>
    </template>
    <span v-else>Список желаний пуст</span>
  </div>
</template>

<script>
import ProductsTableComponent from "components/ProductsTableComponent.vue";
import FileIconComponent from "components/FileIconComponent.vue";
import IconComponent from "components/IconComponent.vue";
import CREATE_SHARED_WISHLIST from "@/graphql/mutations/create_shared_wishlist.graphql";
import GET_SHARED_WISHLIST from "@/graphql/queries/get_shared_wishlist.graphql";
import ShareWishlistModal from "components/modals/components/ShareWishlistModal.vue";

export default {
  name: "WishlistPage",
  data() {
    return {
      sharedWishlistCopied: false,
      pdfLoading: false,
      shareLoading: false,
      loading: false,
    };
  },
  computed: {
    favorites() {
      return this.$store.state.auth.favorites.filter((item) => item.id);
    },
  },
  methods: {
    /**
     * Удаление товаров из избранных
     * @param ids
     * @returns {Promise<void>}
     */
    async remove(ids = []) {
      let index = this.$store.state.auth.favorites.findIndex((item) => item.item_id === ids[0]);
      this.$store.state.auth.favorites.splice(index, 1);
      await this.$store.dispatch("FAVORITE_CREATE_OR_DELETE", {
        apollo: this.$apollo,
        variables: {
          item_id: ids[0],
        },
      });
    },
    async downloadPdf() {
      if (this.pdfLoading) return;

      try {
        // Показываем индикатор загрузки
        this.pdfLoading = true;

        // Проверяем, что список желаний не пуст
        if (this.favorites.length === 0) {
          this.$notify({
            type: "error",
            title: "Ошибка",
            text: "Список желаний пуст",
          });
          return;
        }

        // Открываем PDF страницу в новом окне
        const pdfWindow = window.open(
          this.$router.resolve({ name: "download-pdf", query: { type: "wishlist" } }).href,
          "_blank"
        );

        if (!pdfWindow) {
          // Если блокировщик попапов заблокировал окно, переходим на страницу в текущем окне
          this.$router.push({ name: "download-pdf", query: { type: "wishlist" } });
        }
      } catch (error) {
        // Обработка ошибки
        console.error("Ошибка при открытии PDF страницы:", error);
        this.$notify({
          type: "error",
          title: "Ошибка",
          text: "Произошла ошибка при открытии PDF страницы",
        });
      } finally {
        // Скрываем индикатор загрузки
        this.pdfLoading = false;
      }
    },

    /**
     * Создание общего списка желаний для поделиться
     */
    async shareWishlist() {
      if (this.shareLoading || this.favorites.length === 0) return;

      try {
        // Показываем индикатор загрузки
        this.shareLoading = true;

        // Получаем текущие товары в списке желаний
        const wishlistItems =
          this.favorites.map((item) => ({
            product_id: item.item_id,
            quantity: 1,
          })) || [];

        // Проверяем, что список желаний не пуст
        if (wishlistItems.length === 0) {
          this.$notify({
            type: "error",
            title: "Ошибка",
            text: "Список желаний пуст",
          });
          return;
        }

        // Выполняем запрос к GraphQL API
        const { data } = await this.$apollo.provider.defaultClient.mutate({
          mutation: CREATE_SHARED_WISHLIST,
          variables: {
            input: wishlistItems,
          },
          context: {
            headers: {
              Authorization: "Bearer " + this.$store.state.apollo_token,
            },
          },
        });

        // Проверяем успешность запроса
        if (data && data.createSharedWishlist && data.createSharedWishlist.code === 200) {
          // Получаем hash для создания URL
          const { hash } = data.createSharedWishlist;

          // Создаем URL с query параметром
          const shareUrl = `${window.location.origin}/user/wishlist?hash=${hash}`;

          // Копируем URL в буфер обмена
          this.copyToClipboard(shareUrl);

          // Показываем уведомление об успехе
          this.$notify({
            type: "success",
            title: "Успешно",
            text: "Ссылка на список желаний скопирована в буфер обмена",
          });
        } else {
          // Обработка ошибки
          console.error("Ошибка при создании общего списка желаний:", data?.createSharedWishlist?.message);
          this.$notify({
            type: "error",
            title: "Ошибка",
            text: "Не удалось создать ссылку на список желаний",
          });
        }
      } catch (error) {
        // Обработка ошибки
        console.error("Ошибка при выполнении запроса:", error);
        this.$notify({
          type: "error",
          title: "Ошибка",
          text: "Произошла ошибка при создании ссылки на список желаний",
        });
      } finally {
        // Скрываем индикатор загрузки
        this.shareLoading = false;
      }
    },

    /**
     * Копирование текста в буфер обмена
     */
    copyToClipboard(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      document.body.appendChild(textarea);
      textarea.select();

      try {
        document.execCommand("copy");
      } catch (err) {
        console.error("Не удалось скопировать текст:", err);
      }

      document.body.removeChild(textarea);

      this.sharedWishlistCopied = true;

      // Сбрасываем состояние через 3 секунды
      setTimeout(() => {
        this.sharedWishlistCopied = false;
      }, 3000);
    },

    /**
     * Получение общего списка желаний по hash из URL query параметра
     */
    async fetchSharedWishlist() {
      const hash = this.$route.query.hash;

      if (!hash) {
        return;
      }

      this.loading = true;

      try {
        const { data } = await this.$apollo.provider.defaultClient.query({
          query: GET_SHARED_WISHLIST,
          variables: {
            hash: hash,
          },
          fetchPolicy: "network-only",
        });

        if (data && data.wishlist && data.wishlist.items && data.wishlist.items.length > 0) {
          const sharedWishlistItems = data.wishlist.items.map((item) => ({
            id: item.id,
            quantity: item.quantity,
            item: item.product,
          }));

          this.$store.state._modals.push({
            component: ShareWishlistModal,
            options: {
              wishlistItems: sharedWishlistItems,
              isSharedWishlist: true,
            },
            onClose: () => {
              // Удаляем hash из URL при закрытии модалки
              const query = { ...this.$route.query };
              delete query.hash;
              this.$router.replace({ query });
            },
          });
        } else {
          this.$notify({
            type: "error",
            title: "Ошибка",
            text: "Список желаний не найден или пуст",
          });
        }
      } catch (error) {
        console.error("Ошибка при получении общего списка желаний:", error);
        this.$notify({
          type: "error",
          title: "Ошибка",
          text: "Не удалось загрузить общий список желаний",
        });
      } finally {
        this.loading = false;
      }
    },
  },
  components: { ProductsTableComponent, FileIconComponent, IconComponent },

  mounted() {
    this.fetchSharedWishlist();
  },
};
</script>

<style lang="stylus">
@import "~@/styles/parts/sorts.styl"

.wishlist-page-aside__share {
	display flex
	justify-content flex-end
	gap 1rem
}
</style>
